import api from './_api';
import Vue from 'vue'


const loginUser= async (context,payload) => {    
    let data = new FormData();            
    data.append('email', payload.email);
    data.append('password', payload.password);
    try{
        var response = await api.loginUser(data)
        if (response) {                       
            Vue.dmAuth.setToken(response.data.access_token, response.data.expires_in + Date.now());   
            context.commit('AUTH_SET_AUTH')  
            return response;
        }
    }
    catch(error)  {        
        return Promise.reject(error);
    };    
};
const registerUser= async (context,payload) => {    
    let data = new FormData();            
    data.append('email', payload.email);
    data.append('name', payload.name);
    data.append('password', payload.password);
    data.append('company_id', payload.company_id);
    try{
        var response = await api.registerUser(data)
        if (response) {             
            return response;
        }
    }
    catch(error)  {        
        return Promise.reject(error);
    };    
};
        
const getRegistercompanies = async (context) => {
    try {
        var response = await api.fetchRegistercompanies()                
        context.commit('AUTH_SET_REGISTERCOMPANIES',response.data)        
        return response
    }
    catch(error) {                        
        return Promise.reject(error);
    };    
};

const setAuthenticatedUser = async (context) => {
    try {
        var response = await api.fetchAuthenticatedUser()                
        context.commit('AUTH_SET_USER',response.data)        
        return response
    }
    catch(error) {                        
        return Promise.reject(error);
    };    
};


export default {
  loginUser,
  registerUser,
  getRegistercompanies,
  setAuthenticatedUser
};